/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/search-results/__generated__/searchResultsAsyncQuery.graphql.ts
 */

export const SEARCH_RESULTS_ASYNC_QUERY_PERSISTED_ID = '929cb40c8421910923cc1b654f8601af59d22ab4f38d19384d91ed4677abf87a';
export const SEARCH_RESULTS_ASYNC_QUERY_OPERATION_NAME = 'searchResultsAsyncQuery';
